/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { MenuGroupMinWidth } from '@jira/navigation-apps__constants/src/MenuGroupMinWidth.tsx';
import SkeletonItem from '@atlaskit/menu/skeleton-item';
import MenuGroup from '@atlaskit/menu/menu-group';
import Section from '@atlaskit/menu/section';

export const Skeleton = (): React.JSX.Element => (
	<MenuGroup minWidth={MenuGroupMinWidth}>
		<Section isList>
			<SkeletonItem />
			<SkeletonItem />
			<SkeletonItem />
		</Section>
	</MenuGroup>
);
